export enum AppRoutes {
  DASHBOARD = '/dashboard',
  HEALTH = 'health',
  UNAUTHORIZED = '/unauthorized',
  NOT_FOUND = '/404',
}
